import { render, staticRenderFns } from "./WebSiteCourseList.vue?vue&type=template&id=6c4d0578&scoped=true"
import script from "./WebSiteCourseList.vue?vue&type=script&lang=js"
export * from "./WebSiteCourseList.vue?vue&type=script&lang=js"
import style0 from "./WebSiteCourseList.vue?vue&type=style&index=0&id=6c4d0578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d0578",
  null
  
)

export default component.exports